// lib
import React from 'react'
import { RouteComponentProps } from 'react-router'

// components
import MetaTags from 'src/components/meta_tags/meta_tags'
import MailBox from 'src/containers/mailbox'
import StandardPageTitle from 'src/containers/smart_components/page_title/page_title'
import LayoutNoMap from 'src/layout/layout_no_map'

// constants & interfaces
import { MAILBOX_PAGE_TITLE } from 'src/constants/meta_tags'
import { textResources } from 'src/lang/de'

// helpers
import { usePageTracking } from 'src/pages/hooks/hooks'
import { useSelectUser } from 'src/reducers/user/user_hooks'

const MailboxPage: React.FC<RouteComponentProps> = () => {
  const user = useSelectUser()

  usePageTracking({ user })

  return (
    <>
      <MetaTags
        title={MAILBOX_PAGE_TITLE}
      />
      <LayoutNoMap pageTitle={<StandardPageTitle text={textResources.pageTitles.inbox} />}>
        <MailBox />
      </LayoutNoMap>
    </>
  )
}

export default MailboxPage
